/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundFamilyCreateParams
} from '../../model/fundFamilyCreateParams'
import type {
  FundFamilyData
} from '../../model/fundFamilyData'
import type {
  FundFamilyDataList
} from '../../model/fundFamilyDataList'
import type {
  FundFamilyDataRequest
} from '../../model/fundFamilyDataRequest'
import type {
  FundFamilyDestroyParams
} from '../../model/fundFamilyDestroyParams'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  FundFamilyEventDataRequest
} from '../../model/fundFamilyEventDataRequest'
import type {
  FundFamilyEventReadDataList
} from '../../model/fundFamilyEventReadDataList'
import type {
  FundFamilyListParams
} from '../../model/fundFamilyListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List all Fund Families
 */
export const fundFamilyList = (
    params?: FundFamilyListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyDataList>(
      {url: `/fund-family/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundFamilyListQueryKey = (params?: FundFamilyListParams,) => {
    return [`/fund-family/`, ...(params ? [params]: [])] as const;
    }

    
export const getFundFamilyListQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyList>>, TError = unknown>(params?: FundFamilyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyList>>> = ({ signal }) => fundFamilyList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyListQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyList>>>
export type FundFamilyListQueryError = unknown

export const useFundFamilyList = <TData = Awaited<ReturnType<typeof fundFamilyList>>, TError = unknown>(
 params?: FundFamilyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyList>>, TError = unknown>(params?: FundFamilyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyList>>> = ({ signal }) => fundFamilyList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyList>>>
export type FundFamilyListSuspenseQueryError = unknown

export const useFundFamilyListSuspense = <TData = Awaited<ReturnType<typeof fundFamilyList>>, TError = unknown>(
 params?: FundFamilyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyListLoader = (queryParamsOrFn?: (FundFamilyListParams | ((params: Params) => FundFamilyListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getFundFamilyListQueryKey(queryParams),
            queryFn: () => fundFamilyList(queryParams),
          }).then(() => null);
        });
      /**
 * Create a new Fund Family
 */
export const fundFamilyCreate = (
    fundFamilyDataRequest: FundFamilyDataRequest,
    params?: FundFamilyCreateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyData>(
      {url: `/fund-family/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyDataRequest,
        params
    },
      options);
    }
  


export const getFundFamilyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyCreate>>, TError,{data: FundFamilyDataRequest;params?: FundFamilyCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyCreate>>, TError,{data: FundFamilyDataRequest;params?: FundFamilyCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyCreate>>, {data: FundFamilyDataRequest;params?: FundFamilyCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  fundFamilyCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyCreate>>>
    export type FundFamilyCreateMutationBody = FundFamilyDataRequest
    export type FundFamilyCreateMutationError = unknown

    export const useFundFamilyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyCreate>>, TError,{data: FundFamilyDataRequest;params?: FundFamilyCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Lists fund family events for a fund family
 */
export const fundFamilyEventList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyEventReadDataList>(
      {url: `/fund-family/${fundFamilyId}`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyEventListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}`] as const;
    }

    
export const getFundFamilyEventListQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventList>>> = ({ signal }) => fundFamilyEventList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventListQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventList>>>
export type FundFamilyEventListQueryError = unknown

export const useFundFamilyEventList = <TData = Awaited<ReturnType<typeof fundFamilyEventList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyEventListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventList>>> = ({ signal }) => fundFamilyEventList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventList>>>
export type FundFamilyEventListSuspenseQueryError = unknown

export const useFundFamilyEventListSuspense = <TData = Awaited<ReturnType<typeof fundFamilyEventList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyEventListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyEventListQueryKey(fundFamilyId),
              queryFn: () => fundFamilyEventList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a new fund family event
 */
export const fundFamilyEventCreate = (
    fundFamilyId: string,
    fundFamilyEventDataRequest: FundFamilyEventDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyEventDataRequest
    },
      options);
    }
  


export const getFundFamilyEventCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCreate>>, TError,{fundFamilyId: string;data: FundFamilyEventDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCreate>>, TError,{fundFamilyId: string;data: FundFamilyEventDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventCreate>>, {fundFamilyId: string;data: FundFamilyEventDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  fundFamilyEventCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCreate>>>
    export type FundFamilyEventCreateMutationBody = FundFamilyEventDataRequest
    export type FundFamilyEventCreateMutationError = unknown

    export const useFundFamilyEventCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCreate>>, TError,{fundFamilyId: string;data: FundFamilyEventDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific Fund Family
 */
export const fundFamilyRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyData>(
      {url: `/fund-family/${fundFamilyId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/`] as const;
    }

    
export const getFundFamilyRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyRetrieve>>> = ({ signal }) => fundFamilyRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyRetrieve>>>
export type FundFamilyRetrieveQueryError = unknown

export const useFundFamilyRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyRetrieve>>> = ({ signal }) => fundFamilyRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyRetrieve>>>
export type FundFamilyRetrieveSuspenseQueryError = unknown

export const useFundFamilyRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyRetrieveQueryKey(fundFamilyId),
              queryFn: () => fundFamilyRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a specific Fund Family
 */
export const fundFamilyUpdate = (
    fundFamilyId: string,
    fundFamilyDataRequest: FundFamilyDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyData>(
      {url: `/fund-family/${fundFamilyId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyDataRequest
    },
      options);
    }
  


export const getFundFamilyUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyUpdate>>, TError,{fundFamilyId: string;data: FundFamilyDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyUpdate>>, TError,{fundFamilyId: string;data: FundFamilyDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyUpdate>>, {fundFamilyId: string;data: FundFamilyDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  fundFamilyUpdate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyUpdate>>>
    export type FundFamilyUpdateMutationBody = FundFamilyDataRequest
    export type FundFamilyUpdateMutationError = unknown

    export const useFundFamilyUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyUpdate>>, TError,{fundFamilyId: string;data: FundFamilyDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a Fund Family
 */
export const fundFamilyDestroy = (
    fundFamilyId: string,
    params?: FundFamilyDestroyParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getFundFamilyDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDestroy>>, TError,{fundFamilyId: string;params?: FundFamilyDestroyParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDestroy>>, TError,{fundFamilyId: string;params?: FundFamilyDestroyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyDestroy>>, {fundFamilyId: string;params?: FundFamilyDestroyParams}> = (props) => {
          const {fundFamilyId,params} = props ?? {};

          return  fundFamilyDestroy(fundFamilyId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyDestroy>>>
    
    export type FundFamilyDestroyMutationError = unknown

    export const useFundFamilyDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDestroy>>, TError,{fundFamilyId: string;params?: FundFamilyDestroyParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    